var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconVideoOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 30,
    viewBox: "0 0 30 30",
    width: 30,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m17.5777 7.02522c-2.9566-.31065-5.9365-.33376-8.89755-.069l-1.97723.17679c-1.63394.14609-2.95412 1.39434-3.19142 3.01749-.47017 3.2159-.47017 6.4831 0 9.699.2373 1.6232 1.55749 2.8715 3.19142 3.0176l1.97723.1768c2.96115.2647 5.94095.2416 8.89755-.069l.7596-.0799c1.5552-.1634 2.8134-1.3209 3.1164-2.8405l3.8085 2.0234c.2777.1476.6109.1461.8873-.004.2763-.1501.459-.4287.4865-.742l.0311-.3548c.3487-3.9771.3487-7.977 0-11.95413l-.0311-.35481c-.0275-.31327-.2102-.5919-.4865-.74198-.2764-.15007-.6096-.15159-.8873-.00405l-3.8085 2.02345c-.303-1.51956-1.5612-2.67714-3.1164-2.84054zm-8.73057 1.79855c2.84037-.25396 5.69857-.23179 8.53467.06619l.7596.07981c.7645.08033 1.3773.66875 1.4885 1.42933.446 3.0511.446 6.1508 0 9.2018-.1112.7607-.724 1.3491-1.4885 1.4294l-.7596.0798c-2.8361.298-5.6943.3202-8.53467.0662l-1.97723-.1768c-.76957-.0688-1.39136-.6567-1.50313-1.4212-.44386-3.036-.44386-6.1205 0-9.1565.11177-.76452.73356-1.35244 1.50313-1.42124zm12.85277 3.11413c.186 2.0372.186 4.0871 0 6.1242l3.1838 1.6915c.2266-3.165.2266-6.3421 0-9.5071z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVideoOn);
export default __webpack_public_path__ + "static/media/icon_video_on.71877920eccd5a9250ec7b525ee158ac.svg";
export { ForwardRef as ReactComponent };